__turbopack_context__.v({
  "fields": "y9APmW_fields" + " " + __turbopack_context__.i(455038)["fields"],
  "footer": "y9APmW_footer" + " " + __turbopack_context__.i(455038)["footer"],
});
